module.exports = __webpack_public_path__ + "img/shooting_01.178a20ac.jpg";